import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  IconButton,
  Collapse,
} from "@mui/material";

import { Icon } from "@iconify/react";

function FaqPage() {
  return (
    <Box sx={{ mt: 4 }}>
      <Container maxWidth="lg">
        <Typography sx={{ mb: 5 }} textAlign="center" variant="h4">
          Вопросы и ответы
        </Typography>
        <Container maxWidth="md">
          {faqList.map((faq, index) => {
            return <FaqCard key={index} data={faq} style={{ mb: 2 }} />;
          })}
        </Container>
      </Container>
    </Box>
  );
}

function FaqCard({ style = {}, data }) {
  let [isOpen, setIsOpen] = useState(false);

  return (
    <Card sx={{ ...style }} onClick={() => setIsOpen(!isOpen)}>
      <CardContent
        sx={{
          p: "12px 16px !important",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography fontWeight="bold" variant="h6">
            {data.question}
          </Typography>
          <IconButton
            sx={{
              p: 0.5,
              "& svg": {
                color: (t) => t.palette.text.secondary,
              },
            }}
          >
            <Icon
              icon={
                isOpen ? "akar-icons:chevron-up" : "akar-icons:chevron-down"
              }
              width="24"
              height="24"
            />
          </IconButton>
        </Box>
        <Collapse in={isOpen}>
          <Typography sx={{ mt: 1 }} variant="body2">
            {data.answer}
          </Typography>
        </Collapse>
      </CardContent>
    </Card>
  );
}

const faqList = [
  {
    question:
      "Что делать, если я не получил письмо с подтверждением регистрации?",
    answer:
      'Проверьте папку "Спам" в вашей почте. Если письма там нет, попробуйте повторить процесс регистрации или обратитесь в службу поддержки для уточнения статуса вашего аккаунта.',
  },
  {
    question: "Как подключить Telegram к моему аккаунту?",
    answer:
      'Чтобы подключить Telegram, перейдите в раздел Настройки аккаунта (/panel/account), нажмите кнопку "+" рядом с полем Telegram, затем нажмите "Подписаться". Вас перенаправит на Telegram-бота, где вы сможете завершить авторизацию.',
  },
  {
    question: "Зачем нужно пополнять страховой баланс?",
    answer:
      "Страховой баланс необходим для получения заявок на получение средств. Когда вы получаете заявку, система временно замораживает часть вашего страхового баланса на сумму заявки, чтобы гарантировать выполнение обязательств перед клиентом.",
  },
  {
    question:
      "Как добавить банковскую карту и сколько времени занимает проверка?",
    answer:
      'Чтобы добавить карту, перейдите в раздел Реквизиты (/panel/requisites), выберите банк, нажмите "Добавить" и заполните все поля в открывшемся окне. После добавления отправьте карту на проверку. Обычно проверка занимает от нескольких часов до 1–2 рабочих дней.',
  },
  {
    question: "Что делать, если моя карта не прошла проверку?",
    answer:
      "Если ваша карта не прошла проверку, свяжитесь со службой поддержки для уточнения причин. Возможно, потребуется предоставить дополнительные документы или исправить ошибки в данных.",
  },
  {
    question: "Как происходит расчет курса USDT-RUB при пополнении баланса?",
    answer:
      "Курс USDT-RUB определяется автоматически на момент создания заявки на пополнение баланса. Вы можете увидеть текущий курс на панели выше формы пополнения. После перевода средств ваш баланс будет пополнен на сумму в рублях по этому курсу.",
  },
  {
    question:
      "Что делать, если я не успел подтвердить поступление средств по заявке?",
    answer:
      "Если вы не подтвердили поступление средств в течение указанного времени, ваш страховой баланс будет заморожен до тех пор, пока мы не подтвердим, что сумма не была Вам отправлена.",
  },
];

export default FaqPage;
